document.addEventListener("DOMContentLoaded", () => {
  const rotatePolaroidContainer = (item, section) => {
    gsap.fromTo(item,
      {
        rotate: -7.5,
      },
      {
        rotate: 7.5,
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: `+=${window.innerHeight}`,
          scrub: true,
        },
    });
  };

  document.querySelectorAll('.polaroid-container').forEach((item) => {
    if (window.designMode) return;
    rotatePolaroidContainer(item, item.closest('.shopify-section'));
  });
});

